import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { usePermissions } from '@/hooks/useCurrentUser';
/**
 * Permission gate.
 *
 *   <Can code="sales.invoice.create">
 *     <Button>Create invoice</Button>
 *   </Can>
 *
 *   <Can code={["accounting.journal.post", "accounting.journal.unpost"]} mode="any">
 *     ...
 *   </Can>
 */
export function Can({ code, mode = 'all', children, fallback = null }) {
    const allowed = useHasPermission(code, mode);
    return _jsx(_Fragment, { children: allowed ? children : fallback });
}
export function useHasPermission(code, mode = 'all') {
    const { data } = usePermissions();
    if (!data)
        return false;
    if (data.is_admin)
        return true;
    const codes = Array.isArray(code) ? code : [code];
    const set = new Set(data.codes);
    return mode === 'all' ? codes.every((c) => set.has(c)) : codes.some((c) => set.has(c));
}
